import Vue from 'vue';
import { events } from './utils';
import { BIND_DIRECTIVE_EVENT, UNBIND_DIRECTIVE_EVENT, UPDATE_TOOLTIP_EVENT } from './constants';
import { isIOS, isMobile } from '~/components/utils/browser/device';

export default {
  bind(el, binding) {
    if (isIOS() || isMobile()) return;

    Vue.nextTick(() => {
      events.$emit(BIND_DIRECTIVE_EVENT, { el, binding });
    });
  },
  unbind(el) {
    if (isIOS() || isMobile()) return;

    events.$emit(UNBIND_DIRECTIVE_EVENT, el);
  },
  update(el, binding) {
    events.$emit(UPDATE_TOOLTIP_EVENT, { el, binding });
  },
};
